/**
 * Gets the similarity of a string as a percentage
 * @param {String} comparisonString The comparison string
 */
String.prototype.similarity = function (comparisonString) {
    let longer = this.toLowerCase();
    let shorter = comparisonString.toLowerCase();

    if (longer < shorter) {
        const TEMP = shorter;

        shorter = longer;
        longer = TEMP;
    }

    const LONGER_LENGTH = longer.length;
    if (LONGER_LENGTH === 0) {
        return 100;
    }

    return Math.round((LONGER_LENGTH - levenshtein(longer, shorter)) / parseFloat(LONGER_LENGTH) * 100);
};

String.prototype.trimChar = function (character) {
    return this.trimStartChar(character).trimEndChar(character);
};

String.prototype.trimStartChar = function (character) {
    return character !== '' && this.startsWith(character) ? this.slice(1) : this;
};

String.prototype.trimEndChar = function (character) {
    return character !== '' && this.endsWith(character) ? this.slice(0, -1) : this;
};

String.prototype.trimToLength = function (length, addElipsis) {
    const TRIM_LENGTH = (this.length < length) || (typeof length !== 'number') ?
                        this.length :
                        length;

    return addElipsis && TRIM_LENGTH < this.length ?
           `${this.slice(0, (TRIM_LENGTH - 4))} ...` :
           this.slice(0, TRIM_LENGTH);
};

String.prototype.camelCaseToSentence = function () {
    const ARRAY = this.match(/[a-z]+|[A-Z][a-z]+|[0-9]+/g);

    ARRAY[0] = ARRAY[0].split('');
    ARRAY[0][0] = ARRAY[0][0].toUpperCase();
    ARRAY[0] = ARRAY[0].join('');

    return ARRAY.join(' ');
};

String.prototype.toTitleCase = function () {
    let stringAsArray = this.toLowerCase().split(' ');

    stringAsArray = stringAsArray.map(word => word[0].toUpperCase() + word.slice(1));

    return stringAsArray.join(' ');
};

const levenshtein = (a, b) => {
    const ALEN = a.length;
    const BLEN = b.length;

    if (ALEN === 0) return BLEN;
    if (BLEN === 0) return ALEN;

    let tmp, i, j, prev, val, ma, mb, mc, md, bprev;

    if (ALEN > BLEN) {
        tmp = a;
        a = b;
        b = tmp;
    }

    const ROW = new Int8Array(ALEN + 1);
    // init the row
    for (i = 0; i <= ALEN; i++) {
        ROW[i] = i;
    }

    // fill in the rest
    for (i = 1; i <= BLEN; i++) {
        prev = i;
        bprev = b[i - 1];

        for (j = 1; j <= ALEN; j++) {
            if (bprev === a[j - 1]) {
                val = ROW[j - 1];
            }
            else {
                ma = prev + 1;
                mb = ROW[j] + 1;
                mc = ma - ((ma - mb) & ((mb - ma) >> 7));
                md = ROW[j - 1] + 1;
                val = mc - ((mc - md) & ((md - mc) >> 7));
            }

            ROW[j - 1] = prev;
            prev = val;
        }

        ROW[ALEN] = prev;
    }

    return ROW[ALEN];
};
